import React from 'react';

export default ({ className, ...other }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9.984" height="9.81" viewBox="0 0 9.984 9.81">
    <path
      d="M299.531,829.154a2,2,0,0,1-2,2q-1.273.005-2.547,0a.393.393,0,0,0-.312.127q-1.088,1.108-2.186,2.207c-.03.03-.061.058-.114.109v-2.44c-.092,0-.178,0-.263,0a6.864,6.864,0,0,1-.914-.036,1.987,1.987,0,0,1-1.641-1.917q-.015-1.732,0-3.463a2,2,0,0,1,1.981-1.953q2.994,0,5.986,0a2,2,0,0,1,2.007,2Q299.536,827.47,299.531,829.154Z"
      transform="translate(-289.549 -823.783)"
      fill="#fff"
    />
  </svg>
);
